module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "top-bar"
  }, [_c('div', {
    staticClass: "top-bar-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("My SNKR Collection")])], 1), _vm._v(" "), _c('div', {
    staticClass: "top-bar-right"
  }, [_c('ul', {
    staticClass: "menu vertical medium-horizontal"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/sneakers'
      }
    }
  }, [_vm._v("Sneakers")])], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/collection'
      }
    }
  }, [_vm._v("Collection")])], 1) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/wishlist'
      }
    }
  }, [_vm._v("Wishlist")])], 1) : _vm._e(), _vm._v(" "), _c('li', [(_vm.userIsAuthenticated) ? _c('a', {
    staticClass: "logout",
    on: {
      "click": _vm.onLogout
    }
  }, [_vm._v("Log out")]) : _c('router-link', {
    staticClass: "login",
    attrs: {
      "to": {
        path: '/login'
      }
    }
  }, [_vm._v("Log in")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2c63468","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu.vue
// module id = 75
// module chunks = 0